import * as React from "react";
function MdIcon() {
    return React.createElement("path", { d: "M5.25 10.5413V9.45801H14.75V10.5413H5.25Z", fill: "currentColor" });
}
export default MdIcon;
//# sourceMappingURL=Md.js.map